import PropTypes from 'prop-types'
import React from 'react'
import AutocompleteItem from 'components/AutocompleteItem'
import styles from './styles.scss'

const AutocompleteError = ({ message }) => (
  <AutocompleteItem className={styles.error}>
    <span>{ message }</span>
  </AutocompleteItem>
)

AutocompleteError.propTypes = {
  message: PropTypes.string,
}

AutocompleteError.defaultProps = {
  message: '',
}

export default AutocompleteError



// WEBPACK FOOTER //
// ./components/AutocompleteError/index.jsx